import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock, Banknote, Building2, Bookmark, Briefcase, GraduationCap, AlertCircle } from 'lucide-react';
import './JobCard.css';

function formatDate(dateStr) {
  if (!dateStr) return null;
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
  } catch {
    return dateStr;
  }
}

const JobCard = ({ job }) => {
  const slug = job.slug || job.id;
  const location = job.city || job.il || job.location || '';
  const district = job.district || job.ilce || '';
  const companyName = job.companyName || job.company || '';
  const endDate = formatDate(job.endAt || job.endDate);
  const salary = job.salary || (job.startSalary && job.endSalary ? `${job.startSalary} - ${job.endSalary} TL` : job.startSalary ? `${job.startSalary} TL` : null);
  const matchScore = job.matchScore != null ? Math.round(job.matchScore) : null;

  return (
    <Link to={`/ilan/${slug}`} className="job-card">
      <div className="job-card__header">
        <div className="job-card__company-logo">
          <Building2 size={18} />
        </div>
        <div className="job-card__header-info">
          <h3 className="job-card__title">{job.title}</h3>
          {companyName && <p className="job-card__company">{companyName}</p>}
        </div>
        <button className="job-card__bookmark" onClick={(e) => e.preventDefault()}>
          <Bookmark size={14} />
        </button>
      </div>

      <div className="job-card__badges">
        {location && (
          <span className="job-card__badge job-card__badge--location">
            <MapPin size={10} />
            {location}
          </span>
        )}
        {district && (
          <span className="job-card__badge job-card__badge--location">
            {district}
          </span>
        )}
        {job.workingType && (
          <span className="job-card__badge">
            <Briefcase size={10} />
            {job.workingType}
          </span>
        )}
        {job.type && (
          <span className="job-card__badge">
            <Clock size={10} />
            {job.type}
          </span>
        )}
        {endDate && (
          <span className="job-card__badge job-card__badge--deadline">
            <AlertCircle size={10} />
            Son: {endDate}
          </span>
        )}
      </div>

      {job.description && (
        <p className="job-card__desc">{job.description}</p>
      )}

      <div className="job-card__footer">
        <div className="job-card__details">
          {job.experienceYear != null && (
            <span className="job-card__detail-item">
              <Briefcase size={11} />
              {job.experienceYear} yıl
            </span>
          )}
          {(job.educationLevel || job.education) && (
            <span className="job-card__detail-item">
              <GraduationCap size={11} />
              {job.educationLevel || job.education}
            </span>
          )}
          {salary && (
            <span className="job-card__detail-item">
              <Banknote size={11} />
              {salary}
            </span>
          )}
        </div>

        {matchScore != null && matchScore > 0 && (
          <span className="job-card__match-text">%{matchScore} Uyum</span>
        )}
      </div>

      {matchScore != null && matchScore > 0 && (
        <div className="job-card__match-bar">
          <div className="job-card__match-fill" style={{ width: `${matchScore}%` }}></div>
        </div>
      )}
    </Link>
  );
};

export default JobCard;
